import React from 'react';
import FieldSelect from 'common/components/FieldSelect';
import styles from './styles.module.scss';

const FilterSelect = ({
                        placeholder,
                        filter: {
                          value,
                          onChange,
                          onReset
                        },
                        options,
                        isSearchable = true,
                        isAsync = true,
                        defaultOptions = true,
                        disabled = false,
                        showCross = true,
                        containerStyles,
                      }) => {

  return (
    <div className={styles.container}>
      <FieldSelect
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onReset={onReset}
        options={options}
        isSearchable={isSearchable}
        isAsync={isAsync}
        defaultOptions={defaultOptions}
        disabled={disabled}
        showCross={showCross}
        customSingleValueStyles={styles.additionalPadding}
        customControlStyles={styles.noFocusStyles}
        noFocusChanges={true}
        containerStyles={containerStyles}
      />
    </div>
  )
};

export default FilterSelect;